import React from 'react';
import { Link } from 'react-router-dom';
import { Target, Briefcase, BarChart2, ArrowRight } from 'lucide-react';

const CorporateTraining = () => {
  return (
    <div className="bg-white min-h-screen font-sans">

      {/* Hero Section (short, clean header) */}
      <div className="bg-gradient-to-r from-slate-900 to-exiser-primary text-white py-20 relative overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-10"></div>
        <div className="max-w-6xl mx-auto px-6 text-center relative z-10">
          <h1 className="text-4xl md:text-5xl font-bold uppercase leading-tight mb-4">
            Corporate Training & Leadership Development
          </h1>
          <p className="text-lg md:text-xl text-slate-200 max-w-3xl mx-auto leading-relaxed">
            Transform your organization with psychology-driven, results-focused training programs.
          </p>
        </div>
      </div>

      {/* Main Description Section */}
      <div className="bg-gray-50 py-20">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-10">
            <h2 className="text-3xl md:text-4xl font-bold uppercase text-gray-900 mb-4">
              High-Impact Corporate Training Solutions
            </h2>
            <div className="w-24 h-1 bg-exiser-accent mx-auto mb-6" />
            <p className="text-sm tracking-[0.2em] uppercase text-gray-500">
              Psychology-Based • Performance-Oriented • Tailored For Your Growth
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-10 items-start">

            {/* Left - Description */}
            <div className="lg:col-span-2">
              <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-10">
                <p className="text-lg text-gray-700 leading-relaxed mb-6">
                  We provide high-impact corporate training solutions designed to strengthen teams, elevate
                  leadership, and accelerate organizational growth. Our programs combine modern psychology,
                  neuroscience-based performance strategies, and experiential learning to create lasting
                  behavioral change.
                </p>

                <p className="text-lg text-gray-700 leading-relaxed mb-6">
                  Whether your organization needs team-building workshops, leadership development, communication
                  mastery, emotional intelligence training, or growth-focused mindset programs, we deliver
                  customized interventions tailored to your business goals.
                </p>

                <p className="text-lg text-gray-700 leading-relaxed">
                  We help companies build resilient teams, improve collaboration, boost productivity, and develop
                  leaders who can drive consistent, measurable results. Through our corporate workshops, your
                  workforce gains the clarity, confidence, and capability to perform at their peak — professionally
                  and personally.
                </p>
              </div>
            </div>

            {/* Right - Quick Info Card */}
            <div className="space-y-6">
              <div className="bg-slate-900 text-white rounded-2xl p-8 shadow-xl border border-slate-800">
                <h3 className="text-xl font-bold uppercase mb-4">Designed For</h3>
                <ul className="space-y-3 text-sm text-slate-200">
                  <li className="flex items-start gap-2">
                    <Target className="w-4 h-4 text-exiser-accent mt-1" />
                    Leadership & Management Teams
                  </li>
                  <li className="flex items-start gap-2">
                    <Briefcase className="w-4 h-4 text-exiser-accent mt-1" />
                    Fast-Growing Organizations
                  </li>
                  <li className="flex items-start gap-2">
                    <BarChart2 className="w-4 h-4 text-exiser-accent mt-1" />
                    Culture & Performance Transformation
                  </li>
                </ul>

                <Link
                  to="/book"
                  state={{ type: 'individual_corporate' }}
                  className="mt-6 inline-flex items-center gap-2 w-full bg-exiser-accent text-exiser-primary font-bold py-3 px-6 rounded-lg text-sm uppercase hover:bg-white transition-all"
                >
                  Book Corporate Consultation <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  );
};

export default CorporateTraining;
